function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute("aria-expanded",summary.parentNode.hasAttribute("open"));

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  // setTimeout(() => {
  //   if(summary.classList.contains('onLoadclick')){
  //     summary.style.pointerEvents = 'none'
  //   }
  // }, 100);

  summary.addEventListener("click", (event) => {
    if(!summary.classList.contains('onLoadclick')){
      event.currentTarget.setAttribute("aria-expanded", !event.currentTarget.closest("details").hasAttribute("open"));
    } else {
      if (!event.currentTarget.closest("details").hasAttribute("open")) {
        document.querySelector('#MainContent').style.paddingTop = 'var(--megamenu-offset)';
      } else {
        document.querySelector('#MainContent').style.paddingTop = '0px';
      }
    }
  });
  if(summary.parentElement.classList.contains("header_details")){
  summary.addEventListener("mouseenter", (event) => {
    event.currentTarget.setAttribute("aria-expanded", !event.currentTarget.closest("details").hasAttribute("open"));

    //== Desktop Header MegaMenu Open ====
    if (event.currentTarget.classList.contains("header__menu-item") && !event.currentTarget.closest("details").hasAttribute("open")) {
      event.currentTarget.closest("details").setAttribute("open", "");
    }
    if (summary.classList.contains('onLoadclick') && !document.querySelector(".section-header").classList.contains("shopify-section-header-sticky")) {
      document.querySelector('#MainContent').style.paddingTop = 'var(--megamenu-offset)';
    }

    summary.parentElement.addEventListener("mouseleave", (event) => {
      if(!summary.classList.contains('onLoadclick')){
      if (event.currentTarget.classList.contains("header__menu-item") && !event.currentTarget.closest("details").hasAttribute("open")) {
        return;
      } else {
        event.currentTarget.closest("details").removeAttribute("open", "");
      }
    }
    });

  });
  }

  if (summary.closest("header-drawer")) return;
    summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary")
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);

      if (window.matchMedia("(max-width: 990px)")) {
        document.documentElement.style.setProperty(
          "--viewport-height",
          `${window.innerHeight}px`
        );
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header =
      this.header || document.getElementById("shopify-section-header") || document.querySelector(".section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom"
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
  }
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
        this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
      )
    ) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this))
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener(
      "click",
      this.autoPlayToggle.bind(this)
    );
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active"
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft +
          this.slider.querySelector(".slideshow__slide").clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll("a");
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute("tabindex");
          });
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute("tabindex", "-1");
          });
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(
      `[id^="MediaGallery-${this.dataset.section}"]`
    );
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(
        `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        true
      )
    );

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    );
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(
          `price-${this.dataset.section}`
        );
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("visibility-hidden");
        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut
        );
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (
            !this.querySelector("slideshow-component") &&
            this.classList.contains("complementary-products")
          ) {
            this.remove();
          }

          if (html.querySelector(".grid__item")) {
            this.classList.add("product-recommendations--loaded");
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("product-recommendations", ProductRecommendations);

class LocationModal extends HTMLElement {
  constructor() {
    super();

    var CookieDate = new Date;
    CookieDate.setFullYear(CookieDate.getFullYear() +10);        
    //document.cookie = `delivery_location=Denmark; path=/;expires=${new Date(new Date().getTime()+1000*60*60*24*365).toGMTString()};`;

    this.mainOrigin = 'https://dookan.com';
    this.europeOrigin = 'https://eu.dookan.com';  
    this.url = window.location.href;
    this.search = window.location.search;
    this.urlOrigin = window.location.origin;
    this.urlPath = window.location.pathname;
    this.params = new URLSearchParams(this.search);
    this.oldPathValue = this.params.get("delivery_location");
    this.pathValue = this.params.get("country");
    if (this.params.get("country") !== null) {
      this.pathValue = this.params.get("country").toLowerCase();
    }

    if(this.oldPathValue){
      document.cookie = `delivery_location=${this.pathValue}; path=/;expires=${new Date(new Date().getTime()+0*60*60*24*365).toGMTString()};`;
      this.locationlist = document.querySelectorAll("#DetailsLocationList button");
      this.locationlist.forEach((country) =>{
        if(this.oldPathValue ==  country.getAttribute("data-location")){
          this.urlValue = country.getAttribute("data-country");
        }
      });
      document.cookie = `country=${this.urlValue}; path=/;expires=${new Date(new Date().getTime()+1000*60*60*24*365).toGMTString()};`;
      this.pathValue = this.urlValue;
      console.log(this.oldPathValue,this.pathValue, this.urlValue);
      window.location.search = `country=${this.urlValue}`;
    }
    if(this.pathValue){
      document.cookie = `country=${this.pathValue};path=/; expires=${new Date(new Date().getTime()+1000*60*60*24*365).toGMTString()};`;
      if(this.pathValue == 'ch'){
        if(document.cookie.split("; ").find((row) => row.startsWith("localization="))?.split("=")[1] != 'DE'){
          this.updateLocalization({country: "DE"});
        }        
      }
      this.locations = new Array("at","be","bg","hr","cz","dk","ee","fi","fr","de","hu","it","lv","lt","lu","nl","pl","ro","sk","si","es","se","ch","pt","gr");
      this.location = false;
      this.locations.forEach((location) => {        
        if(location == this.pathValue){          
          this.location = true
        }
      });
      if(!this.location){
        document.cookie = `country=de; path=/;expires=${new Date(new Date().getTime()+1000*60*60*24*365).toGMTString()};`;
        if(document.cookie.split("; ").find((row) => row.startsWith("localization="))?.split("=")[1] != 'DE'){
          this.updateLocalization({country: "DE"});
        }
      }
    }
    this.cookieValue = document.cookie.split("; ").find((row) => row.startsWith("country="))?.split("=")[1];
    this.cookieOldValue = document.cookie.split("; ").find((row) => row.startsWith("delivery_location="))?.split("=")[1];
    if(this.cookieOldValue){
      console.log(this.cookieOldValue);
      this.locationlist = document.querySelectorAll("#DetailsLocationList button");
      this.locationlist.forEach((country) =>{
        if(this.cookieOldValue ==  country.getAttribute("data-location")){
          this.cookieValue = country.getAttribute("data-country");
        }
      });
      document.cookie = `delivery_location=${this.pathValue}; path=/;expires=${new Date(new Date().getTime()+0*60*60*24*365).toGMTString()};`;
      document.cookie = `country=${this.cookieValue}; path=/;expires=${new Date(new Date().getTime()+1000*60*60*24*365).toGMTString()};`;
      window.location.search = `country=${this.cookieValue}`;
      //console.log(this.cookieValue);
    }
    
    if(this.cookieValue){
       // Main URL Setup
        this.mainURL =  new URL(this.mainOrigin + window.location.pathname.replace('/cs','') + window.location.search);
        this.mainParams = new URLSearchParams(this.mainURL.search);    
        this.mainParams.set('country',this.cookieValue);    
        this.mainOutput = this.mainParams.toString();        
        this.mainURL = new URL(this.mainOrigin + window.location.pathname.replace('/cs','') + '?' + this.mainOutput);
       // console.log('COM', this.mainURL);
        
        // Europe URL Setup
        this.europeURL =  new URL(this.europeOrigin + window.location.pathname.replace('/cs','') + window.location.search);
        this.europeParams = new URLSearchParams(this.europeURL.search);    
        this.europeParams.set('country',this.cookieValue);    
        this.europeOutput = this.europeParams.toString();
        this.europeURL = new URL(this.europeOrigin + window.location.pathname.replace('/cs','') + '?' + this.europeOutput);
      //  console.log('EU', this.europeURL);
    
        if(this.cookieValue == 'cz'){
          window.location.href= this.mainURL;
        }else{
          if(this.europeOrigin != window.location.origin){
             window.location.href= this.europeURL; 
          }          
        }
    }
  }
  updateLocalization({country}) {
    const formId = crypto.randomUUID();
    const formHtml = `
      <form id="${formId}" action="/localization" method="POST" hidden>
        <input name="_method" value="PUT">
        <input name="country_code" value="${country}">
      </form>
    `;
    document.body.insertAdjacentHTML("beforeend", formHtml);
    document.getElementById(formId).submit();
  }
  connectedCallback() {    
    this.location = document.querySelector("#PopupLocation summary");
    this.drawerLocation = document.querySelector("#DetailsDrawerLocation");
    this.locationlist = document.querySelectorAll("#DetailsLocationList button");
    this.submit = document.querySelector("#DetailsLocation summary > button");
    this.drawerLocation.addEventListener("click", this.onDrawerClick);
    this.locationlist.forEach((element) => element.addEventListener("click", this.onClick));
    this.submit.addEventListener("click", this.onSubmit);    

    // Checking Cookie value
    if(this.cookieValue){
      this.locationlist.forEach((country) =>{
        //console.log(country.getAttribute("data-country"),this.cookieValue);
        if(this.cookieValue ==  country.getAttribute("data-country")){
          this.country_value = country.getAttribute("data-location");
        }
      })
      
       document.querySelector("#DetailsLocation summary > span").innerHTML = this.country_value;
       document.querySelector("#DetailsDrawerLocation > summary > span").innerHTML = this.country_value;
       document.querySelector("#PopupLocation > summary > span").innerHTML = this.country_value;
       document.querySelector(".location_label").classList.remove('hidden');
       document.querySelector("#DetailsLocation button").removeAttribute('disabled');
       this.locationlist.forEach((element) => {
         if(element.dataset.location == this.country_value){
           element.classList.add('list-menu__item--active');
         }
       });       
    }
    else{
      if (!Shopify.designMode) {
        setTimeout(() => { this.location.click(); document.body.classList.add("overflow-hidden"); }, 1000);
      }
    }
  }
  onDrawerClick() {
    document.querySelector("#PopupLocation").setAttribute("open", true);
    setTimeout(() => {
      document.querySelector("#DetailsDrawerLocation").removeAttribute("open");
      document.body.classList.add("overflow-hidden");
    }, 200);
  }
  onClick() {
    if (document.querySelectorAll("#DetailsLocationList button.list-menu__item--active").length > 0) {
      document.querySelector("#DetailsLocationList button.list-menu__item--active").classList.remove("list-menu__item--active");
    }
    this.classList.add("list-menu__item--active");
    document.querySelector("#DetailsLocation summary > button").removeAttribute('disabled');
    document.querySelector("#DetailsLocation summary > span").innerHTML = this.getAttribute("data-location");
    document.querySelector("#DetailsLocation summary").click();
  }

  onSubmit() {
    this.active = document.querySelector("#DetailsLocationList .list-menu__item--active");
    this.selected = this.active.getAttribute("data-country");
    this.selected_name = this.active.getAttribute("data-location");
    this.popText = document.querySelector("#PopupLocation > summary > span");
    this.drawerText = document.querySelector("#DetailsDrawerLocation > summary > span");
    this.close = document.querySelector("location-modal .modal__close-button");
    this.label = document.querySelector(".location_label");

    this.popText.innerHTML = this.selected_name;
    this.drawerText.innerHTML = this.selected_name;
    this.label.classList.remove('hidden');
    this.close.click();

    // Set location cookie value 
    var CookieDate = new Date;
    CookieDate.setFullYear(CookieDate.getFullYear() +10);
    document.cookie = `country=${this.selected}; path=/;expires=${new Date(new Date().getTime()+1000*60*60*24*365).toGMTString()};`;
    //var cookieValue = document.cookie.split("; ").find((row) => row.startsWith("delivery_location="))?.split("=")[1];    

    // Set url parameters value
    this.cookieValue = document.cookie.split("; ").find((row) => row.startsWith("country="))?.split("=")[1];
    this.mainOrigin = 'https://dookan.com';
    this.europeOrigin = 'https://eu.dookan.com';    
    this.url = window.location.href;
    this.urlOrigin = window.location.origin;
    this.urlPath = window.location.pathname;
    this.params = new URLSearchParams(this.url.search);
    this.params.set("country", this.cookieValue);

    // Main URL Setup
    this.mainURL =  new URL(this.mainOrigin + window.location.pathname.replace('/cs','') + window.location.search);
    this.mainParams = new URLSearchParams(this.mainURL.search);    
    this.mainParams.set('country',this.cookieValue);    
    this.mainOutput = this.mainParams.toString();        
    this.mainURL = new URL(this.mainOrigin + window.location.pathname.replace('/cs','') + '?' + this.mainOutput);
   // console.log('COM', this.mainURL);
    
    // Europe URL Setup
    this.europeURL =  new URL(this.europeOrigin + window.location.pathname.replace('/cs','') + window.location.search);
    this.europeParams = new URLSearchParams(this.europeURL.search);    
    this.europeParams.set('country',this.cookieValue);    
    this.europeOutput = this.europeParams.toString();        
    this.europeURL = new URL(this.europeOrigin + window.location.pathname.replace('/cs','') + '?' + this.europeOutput);
  //  console.log('EU', this.europeURL);

    if(this.cookieValue == 'cz'){
      window.location.href= this.mainURL;
    }else{
      window.location.href= this.europeURL;
    }
    
  }  
}
customElements.define("location-modal_old", LocationModal);

window.setGridHeight = (selector) => {
  this.heightArray = [];
  this.offsetArrayArray = [];
  this.sectionArray = [];

  document.querySelectorAll(selector).forEach((grid, i) => {
    var tmp = {
      index: i,
      offsetheight: grid.closest(`[data-equal]`).offsetTop,
    };
    this.offsetArrayArray.push(tmp);
  });

  this.diffrentsHeights = [];
  this.offsetArrayArray.forEach(function (e) {
    if (this.diffrentsHeights.includes(e.offsetheight) == false) {
      this.diffrentsHeights.push(e.offsetheight);
    }
  });

  this.diffrentsHeights.forEach(function (e) {
    var data = [];
    for (var i = 0; i < this.offsetArrayArray.length; i++) {
      if (this.offsetArrayArray[i].offsetheight == e) {
        data.push(this.offsetArrayArray[i]);
      }
    }

    var getAllHeightArray = [];
    data.forEach(function (ele) {
      document.querySelectorAll(selector)[ele.index].removeAttribute("style");
      getAllHeightArray.push(document.querySelectorAll(selector)[ele.index].offsetHeight);
    });

    var getMaxHeight = Math.max.apply(Math, getAllHeightArray);
    data.forEach(function (ele) {
      document.querySelectorAll(selector)[ele.index].style.minHeight = getMaxHeight + "px";
    });
  });
};

window.setGridHeight(".product-card-wrapper .card__information .card__heading");
window.setGridHeight(".product-card-wrapper .card__information .price__container");
window.setGridHeight(".review--section .card.card--text");
window.setGridHeight(".article-card-wrapper .card__information");
window.setGridHeight(".multicolumn .multicolumn-card__info");
window.setGridHeight(".multicolumn .multicolumn-card__info h3");
window.setGridHeight(".multicolumn .multicolumn-card__info .rte");


window.onresize = function () {
  window.setGridHeight(".product-card-wrapper .card__information .card__heading");
  window.setGridHeight(".product-card-wrapper .card__information .price__container");
  window.setGridHeight(".review--section .card.card--text");
  window.setGridHeight(".article-card-wrapper .card__information");
  window.setGridHeight(".multicolumn .multicolumn-card__info");
  window.setGridHeight(".multicolumn .multicolumn-card__info h3");
  window.setGridHeight(".multicolumn .multicolumn-card__info .rte");
};


/*=== Megamenu promotion slider ===*/
window.promotion = (selector) => {
  document.querySelectorAll(selector).forEach((element) => {
    if (window.innerWidth < element.scrollWidth) {
      element.classList.add('slide');
        new Flickity(element, {
          cellAlign: 'left',
          wrapAround: false,
          freeScroll: true,
          groupCells: true,
          contain: true,
          prevNextButtons:true,
          pageDots: false,
      })
    }
    else {
      element.classList.remove('slide');
    }
  });
}


window.setGridHeight(".discount_coupon_section .coupon__item .coupon-content");

setTimeout(() => {
window.setGridHeight("product-recommendations .product-card-wrapper .card__information .price__container");
window.setGridHeight("product-recommendations .product-card-wrapper .card__information .card__heading");
  window.setGridHeight(".discount_coupon_section .coupon__item .coupon-content");
}, 600);
setTimeout(() => {
  window.promotion('.mega-menu__promotions-only .promotion__list');
}, 600);

window.onresize = function () {
  setTimeout(() => {
  window.promotion('.mega-menu__promotions-only .promotion__list')
  }, 600);
}

document.getElementById("Details-HeaderMenu-1").addEventListener("mouseenter", (event) => {
  setTimeout(() => {
    if(document.querySelector(".mega-menu__promotions-only .promotion__list:not(.flickity-enabled)")){
      window.promotion('.mega-menu__promotions-only .promotion__list')
    }
    }, 100);
});


/*=== Header Stickty Scroll section ===*/
(function () {
  const internalLinks = document.querySelectorAll('[data-href]');
  if (internalLinks){
  (function(){
    const hashId = window.location.hash;
    //console.log(hashId)
    if(hashId){
      let targetOffset = document.querySelector(`${hashId}`).offsetTop;
      let headerOffset = document.querySelector('.section-header').offsetHeight + 20;
      setTimeout(function(){
      window.scroll({
        top: targetOffset - headerOffset,
        behavior: 'smooth',
      })}, 500);
    }
  })()


  // scrolling js
  

  internalLinks.forEach((link) => {
    console.log(link.getAttribute('data-href').replace("/cs#", "#"));
    link.addEventListener('click', function (e) {
      e.preventDefault();
      if (this.getAttribute('data-href') == '') {
        return;
      }
      let targetOffset = document.querySelector(`${this.getAttribute('data-href').replace("/cs#", "#")}`).offsetTop;
      let headerOffset = document.querySelector('.section-header').offsetHeight;

      console.log(headerOffset);
      if(document.querySelector('body').classList.contains('overflow-hidden-tablet')){
        document.querySelector('body').classList.remove('overflow-hidden-tablet');
      }

      window.scroll({
        top: targetOffset - headerOffset,
        behavior: 'smooth',
      });
    });
  })
  }
})();


class CountdownTimer extends HTMLElement {
  constructor() {
    super();

    this.date = new Date(Date.parse(this.dataset.date)).getTime();
    const dateArray = this.dataset.date.split('.');
    //this.date = new Date(dateArray[2], dateArray[1] - 1, dateArray[0]).getTime();

    if (isNaN(this.date)) {
      this.date = new Date(this.dataset.date.replace(/-/g, "/")).getTime();

      if (isNaN(this.date)) {
        this.unload();
        return;
      }
    }
    
  this.init();
    
    // theme.initWhenVisible({
    //   element: this,
    //   callback: this.init.bind(this),
    //   threshold: 200
    // });
    
  }

  init() {
    this.timer();
    this.dataset.interval = setInterval(this.timer.bind(this), 1000);
  }

  timer() {
    const now = new Date(),
      countTo = new Date(this.date),
      timeDifference = (countTo - now);
      

    if (timeDifference < 0) {
      this.unload();
      return;
    }

    const secondsInADay = 60 * 60 * 1000 * 24,
      secondsInAHour = 60 * 60 * 1000;

    const days = Math.floor(timeDifference / (secondsInADay) * 1);
    const hours = Math.floor((timeDifference % (secondsInADay)) / (secondsInAHour) * 1);
    const mins = Math.floor(((timeDifference % (secondsInADay)) % (secondsInAHour)) / (60 * 1000) * 1);
    const secs = Math.floor((((timeDifference % (secondsInADay)) % (secondsInAHour)) % (60 * 1000)) / 1000 * 1);

    
    const dayHTML = days > 0 ? `<span class="countdown__item">${days} D</span><span class="countdown__seperator">  </span>`: '';
    const hourHTML = `<span class="countdown__item">${hours < 10 ? '0' : ''}${hours}</span><span class="countdown__seperator">:</span>`;
    const minHTML = `<span class="countdown__item">${mins < 10 ? '0' : ''}${mins}</span><span class="countdown__seperator">:</span>`;
    const secHTML = `<span class="countdown__item">${secs < 10 ? '0' : ''}${secs}</span>`;

    this.innerHTML = dayHTML + hourHTML + minHTML + secHTML;
  }

  unload() {
    if (this.dataset.interval) {
      clearInterval(this.dataset.interval);
    }

    this.classList.add('hidden');
  }
}
customElements.define('countdown-timer', CountdownTimer);


// Sagepilot: send ?msg=<encoded message> as a chat message
(function () {
  const url = new URL(location.href);
  const message = (url.searchParams.get("msg") || "").trim();
  if (!message) return;

  // Once per intended action: remove msg before sending
  url.searchParams.delete("msg");
  history.replaceState(null, "", url);

  const timer = setInterval(async () => {
    if (!window.sagepilotWidgetReady) return;
    clearInterval(timer);

    try {
      await window.sagepilotWidgetReady;
      ChatWidget.open();

      let result = await ChatWidget.sendMessage(message);

      // Closed conversation: nothing was sent. Reset the session and send once more.
      if (result.status === "failed" && result.code === "conversation_closed") {
        ChatWidget.logout();
        await new Promise((r) => setTimeout(r, 1500)); // let the widget reload
        ChatWidget.open();
        result = await ChatWidget.sendMessage(message);
      }

      // unknown: may already be sent. Never retry.
      if (result.status === "failed") {
        console.error("Sagepilot send failed:", result.code);
      }
    } catch (err) {
      console.error("Sagepilot error:", err);
    }
  }, 500);
})();